module.exports = __webpack_public_path__ + "img/DiscontentActive.550d72ed.png";